import React, { useState, useEffect } from "react";
import ProfilePicture from "./ProfilePicture";
import LocationComponent from "./LocationComponent";
import BubbleComponent from "./BubbleComponent";
import BookshelfComponent from "./BookshelfComponent";
import SwipeCarouselComponent from "./SwipeCarouselComponent";
import usePageTransition from "./hooks/usePageTransition";
import "./About.css";

const ABOUT_BACKGROUND_CLASS = "about-bg-active";

const About = () => {
  const { transitionStage } = usePageTransition();
  const [contentReady, setContentReady] = useState(false);

  // Effect to set content as ready only when fadeIn starts
  useEffect(() => {
    if (transitionStage === "fadeIn") {
      setContentReady(true);
    } else {
      setContentReady(false);
    }
  }, [transitionStage]);

  // Add about background class to body
  useEffect(() => {
    document.body.classList.add(ABOUT_BACKGROUND_CLASS);
    return () => {
      document.body.classList.remove(ABOUT_BACKGROUND_CLASS);
    };
  }, []);

  return (
    <div className="about-container">
      <div
        className={`main-content-container about-fade-in${
          contentReady ? " visible" : ""
        }`}
      >
        <ProfilePicture
          image="./pp.png"
          name="Evey Griffiths"
          size="200px"
          className={`about-profile about-slide-up${
            contentReady ? " visible" : ""
          }`}
        />
        <div
          className={`content-container about-slide-up-delayed${
            contentReady ? " visible" : ""
          }`}
        >
          <div className="content-left about-fade-in-delayed">
            <LocationComponent />
            <BubbleComponent />
          </div>
          <BookshelfComponent className="about-fade-in-delayed2" />
        </div>
        <SwipeCarouselComponent
          className={`about-fade-in-delayed3${contentReady ? " visible" : ""}`}
        />
      </div>
    </div>
  );
};

export default About;
